<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-10-09 17:16:12
 * @LastEditors: Please set LastEditors
 -->
<template>
    <!-- 出货统计组件 -->
    <div>
          <div class="pageTitle secondTitle">经销商出货统计(统计数据非实时统计,更新截止前一天)</div>
         <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
            <el-tab-pane label="出货经销商统计" name="1" > 
                 <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                         <el-form-item label="出库时间" style="text-align: center">
                            <el-col :span="11">
                                <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time"
                                                style="width: 100%;"></el-date-picker>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time"
                                                style="width: 100%;"></el-date-picker>
                            </el-col>
                        </el-form-item>
                      <el-form-item label="是否赠品:">
                        <el-select v-model="form1.isgift">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="赠品" value="1"></el-option>
                            <el-option label="非赠品" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                  
                   <el-form-item  label="生产批次号:">
                        <el-input v-model="form1.production_batch" clearable ></el-input>
                    </el-form-item>
                      <el-form-item  label="产品编号:">
                        <el-input v-model="form1.product_sn" clearable ></el-input>
                    </el-form-item>
                     <el-form-item  label="产品名称:">
                        <el-input v-model="form1.product_name" clearable ></el-input>
                    </el-form-item>
                      <dealerLeve @leves='getLeve'  >
                      </dealerLeve>
                        <el-form-item label="经销商:">
                            <el-col :span="12">
                                <el-input v-model="form1.from_sn" clearable></el-input>
                            </el-col>
                            <el-col :span="4" style="margin-left: 10px;">
                                <el-button type="primary" @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                            </el-col>
                     </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="onexport()">导出</el-button>

                    </el-form-item>
                </el-form>
                    <div><span>总数量:</span><span>{{total}}</span></div>
                   <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="300"
                border
                stripe
                style="margin: 20px 0;width:95%">
            <el-table-column
                    prop=""
                    label="序号"
                     width="100%"
                    fixed>
                    <template slot-scope="scope">
                        {{scope.$index}}
                    </template>
            </el-table-column>
            <el-table-column
                    prop="from_name"
                    label="经销商名称"
                  
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="from_sn"
                    label="经销商编号"
                    show-overflow-tooltip>
            </el-table-column>
       
            <el-table-column
                    prop="real_stock_out_num"
                    label="出货数量"
                 
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                   
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="出货产品统计" name="2">

                     <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
                     <el-form-item label="出库时间" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form2.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form2.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
                    
                    <!-- <dealerLeve @leves='getLeve'  >
                    </dealerLeve> -->
                    <el-form-item  label="生产批次号:">
                        <el-input v-model="form2.production_batch" clearable ></el-input>
                    </el-form-item>
                      <el-form-item  label="产品编号:">
                        <el-input v-model="form2.product_name" clearable ></el-input>
                    </el-form-item>
                     <el-form-item  label="产品名称:">
                        <el-input v-model="form2.product_name" clearable ></el-input>
                    </el-form-item>
                    <el-form-item label="是否赠品:">
                        <el-select v-model="form2.isgift">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="赠品" value="1"></el-option>
                            <el-option label="非赠品" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                        <el-form-item label="经销商:">
                <el-col :span="12">
                    <el-input v-model="form2.from_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="onexport()"></el-button>

                    </el-form-item>
                </el-form>

                   <el-table
                ref="multipleTable"
                :data="tableData1"
                v-loading="loading"
                height="300"
                border
                stripe
                style="margin: 20px 0;width:95%">
            <el-table-column
                    prop="dealer_sn"
                    label="序号"
                     width="100"
                    fixed>
                       <template slot-scope="scope">
                        {{scope.$index}}
                    </template>
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="product_name"
                    label="产品名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_specs"
                    label="产品规格"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="real_stock_out_num"
                    label="出库数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="pageNo1"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize1">
        </el-pagination>
            </el-tab-pane>
      
        </el-tabs>
                  <!--选择经销商-->
        <selectDealer
                v-if="selectDealerDialog"
                v-on:handleClose='selectDealerDialog = false'
                @pushData="getSelectinfo">
        </selectDealer>
           <el-dialog
      title="明细"
      :visible.sync="DetailDialog"
      width="80%"
      >
        <el-button type="primary" @click="exproDetail" style='margin-bottom:10px'>导出</el-button>
      <el-table
              ref="multipleTable"
              :data="tableData3"
              v-loading="loading"
              border
              stripe
            >
              <el-table-column prop='stock_out_sn' label="出货单号"  >
                
              </el-table-column>
            
              <el-table-column prop='product_sn' label="产品编号" fixed ></el-table-column>             
                            
                            
              <el-table-column prop='product_name'  label="产品名称" fixed width="200"   >
              
              </el-table-column>
              
              <!-- <el-table-column prop='product_sn' label="收货经销商/门店编号" fixed  v-if='activeName==1'></el-table-column>             
                            
                            
              <el-table-column prop='product_name'  label="收货经销商/门店名称" fixed width="200"  v-if='activeName==1'>
              
              </el-table-column> -->
            <el-table-column prop='' label="是否赠品" >
                <template slot-scope="scope">
                    {{scope.row.isgift==1?'赠品':'非赠品'}}
                </template>
            </el-table-column>
              <el-table-column prop='stock_out_time' label="出货时间" ></el-table-column>
              <el-table-column prop='real_stock_out_num' label="出货数量" ></el-table-column>
              <el-table-column prop='logistics_code' label="物流码" ></el-table-column>
              <el-table-column prop='code_name' label="类型" ></el-table-column>

            </el-table>
                    <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="pageNo3"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize3"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize3"
            ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DetailDialog = false,pageSize3=10,pageNo3=1">取 消</el-button>
        <el-button type="primary" @click="DetailDialog = false,pageSize3=10,pageNo3=1">确 定</el-button>
      </span>
    </el-dialog>
    </div>
</template>


<script>
 import selectDealer from '../../../common/selectDealer';
 import dealerLeve from '../../../common/dealerLeve'
export default {
    name:'outPut',
    data(){
        return{
            loading:false,
            selectDealerDialog:false,
            DetailDialog:false,
            tableData3:[],
            activeName:'1',
            total:0,
             form1:{
                 end_time:"",
                 start_time:"",
                 isgift:"",
                 from_sn:"",
                 product_sn:"",
                 product_name:"",
                 production_batch:"",
             },
      
             form2:{
                       end_time:"",
                 start_time:"",
                 isgift:"",
                 from_sn:"",
                 product_sn:"",
                 product_name:"",
                 production_batch:"",
             },
              pageNo: 1,
              pageSize: 20,
              totalSize: 0,
               pageNo1: 1,
              pageSize1: 20,
              totalSize1: 0,
              tableData:[],
              tableData1:[],
               pageNo3: 1,
              pageSize3: 10,
              totalSize3: 0,
              detailData:{}
        }
    },
    methods:{
        // 获取经销商等级
        getLeve(value){
            this.form1.dealer_level_id=value
            return;
        },
        getSelectinfo(value){
           
        if(this.activeName==1){
                this.form1.from_sn=value.dealer_sn
            }else{
                this.form2.from_sn=value.dealer_sn

            }
        },
        //查看详情
        detail(data){
            this.tableData3=[]
            this.loading=true
            this.DetailDialog=true
            if(data){
                this.detailData=data
            }
            if(this.activeName==1){
                this.$get('logistics','/dealers.stocks.outwarehouses/datas',{
                    from_sn:this.detailData.from_sn,
                    per_page:this.pageSize3,
                    page:this.pageNo3,
                }).then(res=>{
            this.loading=false
                    this.tableData3=res.data
                        this.totalSize3=res.meta.total
                })
            }else{
                  this.$get('logistics','/dealers.stocks.out.products/datas',{
                    product_sn :this.detailData.product_sn ,
                    per_page:this.pageSize3,
                    page:this.pageNo3,
                }).then(res=>{
            this.loading=false

                        this.totalSize3=res.meta.total
                    this.tableData3=res.data
                })
            }
        },
        // 导出详情
        exproDetail(){
                      let url = "",
                        access_tokens = localStorage.getItem("access_tokens");
                  
            if(this.activeName==1){
                window.open(
               this.$Base_Export+
                "/dealers.stocks.outwarehouses/datas.export?from_sn="+this.detailData.from_sn+   
                "&lang=" +''+
                '&is_export=1'+
                "&signature=" +
                this.$md5(access_tokens)
            );
            }else{
     window.open(
                this.$Base_Export +
                "/dealers.stocks.out.products/datas.export?product_sn ="+this.detailData.product_sn+   
                "&lang=" +''+
                '&is_export=1'+
                "&signature=" +
                this.$md5(access_tokens)
            );
            }
        },
        onSearch(){
            this.loading=true
            if(this.activeName==1){
                if (this.form1.start_time) {
                    this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
                }
                if (this.form1.end_time) {
                    this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                }
                this.$get('logistics','/dealers.stocks.outwarehouses',{
                    per_page:this.pageSize,
                    page:this.pageNo,
                    ...this.form1
                }).then(res=>{
                     this.loading=false
                    this.tableData=res.data
                    this.totalSize=res.meta.total
                    this.total=res.real_stock_out_num
                }).catch(error=>{
                 this.loading=false
                })
            }else{
                  if (this.form2.start_time) {
                    this.form2.start_time = this.moment(this.form2.start_time).format("YYYY-MM-DD");
                }
                if (this.form2.end_time) {
                    this.form2.end_time = this.moment(this.form2.end_time).format("YYYY-MM-DD");
                }
                this.$get('logistics','/dealers.stocks.out.products',{
                    per_page:this.pageSize1,
                    page:this.pageNo1,
                    ...this.form2
                }).then(res=>{
                     this.loading=false
                    this.tableData1=res.data
                    this.totalSize1=res.meta.total
                    this.total=res.real_stock_out_num
                }).catch(error=>{
                 this.loading=false
                })
            }
        },
        handleSizeChange(val){
            this.pageSize=val
            this.onSearch()
        },
        handleCurrentChange(val){
            this.pageNo=val

            this.onSearch()

        },
           handleSizeChange1(val){
            this.pageSize1=val
            this.onSearch()
        },
        handleCurrentChange1(val){
            this.pageNo1=val
            this.onSearch()
        },
             handleSizeChange3(val){
            this.pageSize3=val
            this.detail()
        },
        handleCurrentChange3(val){
            this.pageNo3=val
            this.detail()
        },
        handleClick(){
            console.log('aa')
            this.onSearch()
        },
        onexport(){
              let url = "",
        access_tokens = localStorage.getItem("access_tokens");
      if(this.activeName==1){
            if (this.form1.start_time) {
                    this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
                }
                if (this.form1.end_time) {
                    this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                }
           
window.open(
       this.$Base_Export+
          "/dealers.stocks.outwarehouses.export?start_time="+this.form1.start_time+   
          '&end_time='+this.form1.end_time+
          '&isgift='+this.form1.isgift+
          '&from_sn='+this.form1.from_sn+
          '&product_sn='+this.form1.product_sn+
          '&product_name='+this.form1.product_name+
          '&production_batch='+this.form1.production_batch+
          "&lang=" +''+
          '&is_export=1'+
          "&signature=" +
          this.$md5(access_tokens)
      );
      }else{
            if (this.form2.start_time) {
                    this.form2.start_time = this.moment(this.form2.start_time).format("YYYY-MM-DD");
                }
                if (this.form2.end_time) {
                    this.form2.end_time = this.moment(this.form2.end_time).format("YYYY-MM-DD");
                }
window.open(
        this.$Base_Export+
         "/dealers.stocks.out.products.export?start_time="+this.form2.start_time+   
          '&end_time='+this.form2.end_time+
          '&isgift='+this.form2.isgift+
          '&from_sn='+this.form2.from_sn+
          '&product_sn='+this.form2.product_sn+
          '&product_name='+this.form2.product_name+
          '&production_batch='+this.form2.production_batch+
          "&lang=" +''+
          '&is_export=1'+
          "&signature=" +
          this.$md5(access_tokens)
      );
      }
        }
    },
    mounted:{
        
    },
    created(){
        this.onSearch()
    },
    components:{
        selectDealer,
        dealerLeve
    }
}
</script>
